import {
    STORE_CALLS_COLLECTION,
    FIELD_PANEL_CALL,
    END_PANEL_CALL,
    FIELD_PANEL_CALL_SUCCESS,
    END_PANEL_CALL_SUCCESS,
    FIELD_PANEL_CALL_FAILURE,
    END_PANEL_CALL_FAILURE,
    RESUME_PANEL_CALL
} from './types';

export const storeCallsCollection = calls => {
    return {
        type: STORE_CALLS_COLLECTION,
        payload: calls
    };
};

export const fieldPanelCall = data => {
    return {
        type: FIELD_PANEL_CALL,
        payload: data
    };
};

export const endPanelCall = data => {
    return {
        type: END_PANEL_CALL,
        payload: data
    };
};

export const fieldPanelCallSuccess = () => {
    return {
        type: FIELD_PANEL_CALL_SUCCESS
    };
};

export const endPanelCallSuccess = () => {
    return {
        type: END_PANEL_CALL_SUCCESS
    };
};

export const fieldPanelCallFailure = error => {
    return {
        type: FIELD_PANEL_CALL_FAILURE,
        payload: error
    };
};

export const endPanelCallFailure = error => {
    return {
        type: END_PANEL_CALL_FAILURE,
        payload: error
    };
};

// Picks back up a call this operator already fielded (status 'active') but the page no
// longer holds - e.g. after a reload mid-call. Unlike fieldPanelCall it writes nothing.
export const resumePanelCall = panelCall => {
    return {
        type: RESUME_PANEL_CALL,
        payload: panelCall
    };
};
